module.exports = __webpack_public_path__ + "img/Carousel_4.224d4738.jpg";